import React from 'react'
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined'
import { UI_TEST_ROUTE_PATH } from '@/modules/ui-test/constants'

/** Mục con trong menu Hệ thống. */
export const uiTestSystemMenuItem = {
  id: 'uiTestMenu',
  to: UI_TEST_ROUTE_PATH,
  labelKey: 'components.menu.uiTest',
  icon: <TouchAppOutlinedIcon sx={{ fontSize: 18 }} />,
}
